export * as descriptorUtils from './descriptorUtils'
